import { AddAlert } from '../../../../component';
import { loading, loaded } from '../../../../layout/redux/layoutActions';
import {
  modalOpen,
  setIsLoadingMap,
  setDisplayCharts,
} from '../../redux/dashboardActions';

import { setBigNumbers } from '../../bigNumbers/redux/bigNumbersActions';

import {
  updateInputIntervalsSecondaryGeneral,
  updateRequestStatusSecondary,
  updatePayloadRequest,
  closeInfowindowsSecondary,
  setInfowindowsSecondary,
  updateBuildingData,
  updateChartsDataSecondary,
  storeChartData,
  clearStoragedChartDataSecondary,
} from './offersSecondary.actions';

import {
  getBigNumbersOffersSecondary,
  getModalInfoOffersSecondary,
} from '../infra';

import { generateMarkersOnMap } from '../map';

import infoWindowOffersSecundary from '../components/singleOfferInfowindow';

import {
  buildCoordinatesReverse,
  removeEmptyFromResponse,
} from '../../../../shared/utils';

import { generalMarketsPayloadAdapter } from '../../../../shared/adapters';

import Map from 'eemovel-map-library/src/data/google-maps/map';
import multipleOffersInfowindow from '../components/multipleOffersInfowindow';

export const payloadBuilder = (data, moreFilters, type, cityId) => {
  const location = buildCoordinatesReverse();

  let inputIntervals = {};
  Object.keys(data.inputIntervals).forEach((el) => {
    const val = data.inputIntervals[el];
    if (val.min !== '' && val.max !== '') {
      const validateValue = {
        min: val.min.toString(),
        max: val.max.toString(),
      };
      if (validateValue.min.includes(','))
        validateValue.min = validateValue.min.replace(',', '.');
      if (validateValue.max.includes(','))
        validateValue.max = validateValue.max.replace(',', '.');
      if (validateValue.min.includes('R$')) {
        validateValue.min = validateValue.min
          .split('R$')[1]
          .replaceAll('.', '');
      }
      if (validateValue.max.includes('R$')) {
        validateValue.max = validateValue.max
          .split('R$')[1]
          .replaceAll('.', '');
      }
      const valor =
        el === 'timeframe'
          ? { min: val.min, max: val.max }
          : { min: Number(validateValue.min), max: Number(validateValue.max) };
      inputIntervals = { ...inputIntervals, [el]: valor };
    }
  });
  const newData = {
    ...data,
    ...data?.inputIntervals,
  };
  if (!location) {
    return (dispatch) => {
      dispatch(AddAlert('warning', 'Selecione uma área no mapa'));
    };
  } else {
    const bedrooms = newData.bedrooms
      .filter((el) => el.selected === true)
      .map((elem) => (isNaN(elem.name) ? 4 : Number(elem.name)));
    const suites = newData.suites
      .filter((el) => el.selected === true)
      .map((elem) => (isNaN(elem.name) ? 4 : Number(elem.name)));
    const garages = newData.garages
      .filter((el) => el.selected === true)
      .map((elem) => (isNaN(elem.name) ? 4 : Number(elem.name)));
    const payload = {
      location,
      ...newData,
      bedrooms,
      suites,
      garages,
      ...(moreFilters || {}),
      city_id: Number(cityId),
    };
    return (dispatch) => {
      dispatch(searchRealtyOffersSecondary(payload));
      dispatch(updatePayloadRequest(payload));
    };
  }
};

export const searchRealtyOffersSecondary = (payload) => {
  const formattedPayload = generalMarketsPayloadAdapter(
    payload,
    payload.city_id,
    'secondary'
  );
  return (dispatch) => {
    dispatch([
      loading(),
      clearStoragedChartDataSecondary(),
      updatingRequestsStatus(dispatch, 'LOADING'),
    ]);
    Promise.resolve(getBigNumbersOffersSecondary(formattedPayload))
      .then((response) => {
        if (response?.data) {
          const {
            big_numbers,
            pins,
            ads_amount_on_period,
            ads_over_existent_percentual,
            median_square_meter_price_on_period,
          } = response?.data;

          const bigNumbers = removeEmptyFromResponse(big_numbers);
          const markerType = 'secondary';
          const displayChartKey = 'secondaryMarketGeneral';

          const chartsData = {
            ads_amount_on_period,
            ads_over_existent_percentual,
            average_square_meter_price_on_period:
              median_square_meter_price_on_period,
          };

          if (chartsData) {
            dispatch(storeChartData(chartsData));
          }

          dispatch([
            setBigNumbers(bigNumbers),
            generateMarkersOnMap(pins, markerType, formattedPayload),
            setDisplayCharts(displayChartKey),
          ]);
          updatingRequestsStatus(dispatch, 'LOADED');
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => dispatch(loaded()));
  };
};

export const generateSecondaryMarketGeneralCharts =
  (chartData) => (dispatch) => {
    dispatch(loading());

    if (chartData) {
      const {
        ads_amount_on_period,
        ads_over_existent_percentual,
        average_square_meter_price_on_period,
      } = chartData;

      dispatch([
        updateChartsDataSecondary({
          name: 'realty_announced_by_period',
          value: ads_amount_on_period?.data?.graph,
        }),
        updateChartsDataSecondary({
          name: 'average_realty_announced_by_period',
          value: ads_amount_on_period?.data?.average,
        }),
        updateChartsDataSecondary({
          name: 'price_variation_by_period',
          value: average_square_meter_price_on_period?.data?.graph,
        }),
        updateChartsDataSecondary({
          name: 'ads_per_existing_realties',
          value: ads_over_existent_percentual?.data.graph,
        }),
        updateChartsDataSecondary({
          name: 'average_realties_announced_over_existing_realties',
          value: Number(
            ads_over_existent_percentual?.data.average
              .replace('%', '')
              .replace(',', '.')
          ),
        }),
        loaded(),
      ]);
    } else {
      dispatch(loaded());
    }
  };

export const handlePriceInputs = (e, v, tuple, type) => {
  let name;
  let maskedValue = '';
  const replaceDots = e.value.replaceAll('.', '').split('R$');
  const valueAsFloat =
    replaceDots.length === 2
      ? parseInt(replaceDots[1])
      : parseInt(replaceDots[0]);
  if (!Number.isNaN(valueAsFloat)) {
    maskedValue = valueAsFloat.toLocaleString('pt-br', {
      style: 'currency',
      currency: 'BRL',
      maximumFractionDigits: 0,
    });
  }
  if (e.name.includes('min')) {
    tuple.min = maskedValue;
    name = e.name.split('min')[0];
  } else {
    tuple.max = maskedValue;
    name = e.name.split('max')[0];
  }
  const payload = {
    name,
    value: tuple,
  };
  return (dispatch) => {
    dispatch(updateInputIntervalsSecondaryGeneral(payload));
  };
};

export const handleInputsIntervals = (e, v, tuple, type, typeNumber) => {
  return (dispatch) => {
    let name;
    if (!Number.isNaN(parseInt(e.value)) && parseInt(e.value) < 0) return;
    if (!e.value.match(/^(0|[1-9]\d*)+(,)?(\d{0,3})?$/) && e.value.length > 0)
      return;
    if (e.name.includes('min')) {
      tuple.min =
        typeNumber === 'int'
          ? !Number.isNaN(parseInt(e.value))
            ? parseInt(e.value)
            : ''
          : !Number.isNaN(e.value)
          ? e.value
          : '';
      name = e.name.split('min')[0];
    } else {
      name = e.name.split('max')[0];
      tuple.max =
        typeNumber === 'int'
          ? !Number.isNaN(parseInt(e.value))
            ? parseInt(e.value)
            : ''
          : !Number.isNaN(e.value)
          ? e.value
          : '';
    }
    const payload = {
      name,
      value: tuple,
    };
    dispatch(updateInputIntervalsSecondaryGeneral(payload));
  };
};

const fieldsDictionary = {
  timeframemin: 'Período Inicial',
  timeframemax: 'Período Final',
  privateAreaIntervalmin: 'Área Privativa Inicial',
  privateAreaIntervalmax: 'Área Privativa Final',
  unitPricemin: 'Faixa de preço da Unidade Inicial',
  unitPricemax: 'Faixa de preço da Unidade Final',
  pricePerSquareMtmin: 'Faixa de preço/m² Inicial',
  pricePerSquareMtmax: 'Faixa de preço/m² Final',
  realtyAgemin: 'Idade do Imóvel Inicial',
  realtyAgemax: 'Idade do Imóvel Final',
};

export const validateForm = (
  formData,
  validation,
  type,
  moreFilters,
  cityId
) => {
  let flag = false;
  return (dispatch) => {
    if (!formData.realtyType.id) {
      dispatch(AddAlert('warning', 'Tipo de imóvel é um campo obrigatório'));
      flag = true;
    }
    const errors = [
      ...Object.entries(formData.inputIntervals).filter(
        ([_, value]) => value.min && !value.max
      ),
      ...Object.entries(formData.inputIntervals).filter(
        ([_, value]) => !value.min && value.max
      ),
      ...Object.entries(formData.inputIntervals).filter(
        ([_, value]) =>
          Number(value.min.toString().replaceAll(',', '.')) >
          Number(value.max.toString().replaceAll(',', '.'))
      ),
    ].filter(([_, value]) => !(value.min === 0 && value.max > 0));
    if (errors.length > 0) {
      const fieldsWithErrors = errors.map(
        (el) => fieldsDictionary[`${el[0]}${!el[1].min ? 'min' : 'max'}`]
      );
      const errorNames = fieldsWithErrors.join(', ');
      const isPlural = errors.length > 1;
      dispatch(
        AddAlert(
          'warning',
          `Campo${isPlural ? 's' : ''} inválido${
            isPlural ? 's' : ''
          }: ${errorNames}`
        )
      );
      flag = true;
    }
    if (!Object.values(validation)?.every((el) => el === false)) {
      const removedFalses = Object.entries(validation).filter(
        (el) => el[1] !== false
      );
      const errors = removedFalses.map((el) => fieldsDictionary[el[0]]);
      const invalidFields = errors.join(', ');
      const isPlural = errors.length > 1;
      dispatch(
        AddAlert(
          'warning',
          `Campo${isPlural ? 's' : ''} inválido${
            isPlural ? 's' : ''
          }: ${invalidFields}`
        )
      );
      flag = true;
    }
    if (!flag) {
      const map = document.getElementById('mapsToRender');
      map.addEventListener('click', (e) => {
        if (e?.srcElement?.id === 'info-window-button') {
          dispatch(modalOpen('open building'));
        }
      });
      dispatch(payloadBuilder(formData, null, type, cityId));
    }
  };
};

const buildModalInfoWindowPayload = (payload) => ({
  city_id: payload.city_id,
  realty_type: payload.realty_type,
  ad_type: payload.ad_type,
  street: payload.street,
  number: payload.number,
  min_private_area: payload.min_private_area,
  max_private_area: payload.max_private_area,
  min_transaction_price: payload.min_transaction_price,
  max_transaction_price: payload.max_transaction_price,
  min_sqr_mt_price: payload.min_sqr_mt_price,
  max_sqr_mt_price: payload.max_sqr_mt_price,
  bedrooms: payload.bedrooms,
  suites: payload.suites,
  garages: payload.garages,
});

export const generateInfoWindow = (payload, number, street, marker) => {
  const id = Math.ceil(Math.random() * 100001);
  return (dispatch) => {
    dispatch(loading());
    dispatch(setIsLoadingMap(true));
    dispatch(closeInfowindowsSecondary());
    Promise.resolve(
      getModalInfoOffersSecondary(
        buildModalInfoWindowPayload({
          ...payload,
          street,
          number: number.toString(),
        })
      )
    )
      .then((response) => {
        const {
          data: { data },
        } = response;
        const infoWindowPayload = data.general_info;
        dispatch(updateBuildingData(data));
        const infowindow = infoWindowOffersSecundary({
          payload: infoWindowPayload,
          id,
          marker,
          actions: [
            {
              id: 'SeeAdverts',
              action: () => {
                dispatch(modalOpen('open building secondary-general'));
              },
            },
          ],
        });
        infowindow.open();
        dispatch(setInfowindowsSecondary(infowindow.getInfowindow()));
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        dispatch([loaded(), setIsLoadingMap(false)]);
      });
  };
};

export const generateMultipleAdvertsFoundInfoWindow = (
  payloadArray,
  marker,
  payloadIndex = 0
) => {
  return (dispatch) => {
    dispatch(closeInfowindowsSecondary());
    dispatch(setIsLoadingMap(true));
    dispatch(closeInfowindowsSecondary());
    const payload = payloadArray[payloadIndex];
    Promise.resolve(
      getModalInfoOffersSecondary(
        buildModalInfoWindowPayload({
          ...payload,
          street: payload.processed_address_street,
          number: payload.processed_address_number,
        })
      )
    )
      .then((response) => {
        const {
          data: { data },
        } = response;
        const infoWindowPayload = data.general_info;
        dispatch(updateBuildingData(data));
        const infowindow = multipleOffersInfowindow({
          payload: { ...infoWindowPayload, total_ads: data.ads.length },
          id: payload.id,
          marker: marker,
          map: Map.map,
          index: payloadIndex,
          actions: [
            {
              id: 'SeeAdverts',
              action: () => {
                dispatch(modalOpen('open building secondary-general'));
              },
            },
            {
              id: 'PreviousButton',
              action: () => {
                if (payloadIndex > 0) {
                  dispatch(
                    generateMultipleAdvertsFoundInfoWindow(
                      payloadArray,
                      marker,
                      payloadIndex - 1
                    )
                  );
                  infowindow.previousContent();
                }
              },
            },
            {
              id: 'NextButton',
              action: () => {
                if (payloadIndex < payloadArray.length - 1) {
                  dispatch(
                    generateMultipleAdvertsFoundInfoWindow(
                      payloadArray,
                      marker,
                      payloadIndex + 1
                    )
                  );
                  infowindow.nextContent();
                }
              },
            },
          ],
        });
        infowindow.open();
        dispatch(setInfowindowsSecondary(infowindow.getInfowindow()));
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        dispatch(setIsLoadingMap(false));
      });
  };
};

export const generateBuildingDetailsModal = (data) => {
  return (dispatch) => {
    dispatch([loading(), setIsLoadingMap(true)]);

    dispatch(updateBuildingData(data));
    dispatch(modalOpen('open building secondary-general'));
    dispatch([loaded(), setIsLoadingMap(false)]);
  };
};

const updatingRequestsStatus = (dispatch, status) => {
  dispatch([
    updateRequestStatusSecondary({
      name: 'realtyAnnouncedByPeriod',
      value: status,
    }),
    updateRequestStatusSecondary({
      name: 'adsPerExistingRealties',
      value: status,
    }),
    updateRequestStatusSecondary({
      name: 'averagePricePerSqMt',
      value: status,
    }),
  ]);
};
